import { FullScreenViewer } from 'iv-viewer';
import { Injectable } from '@angular/core';
import { Platform, ToastController } from 'ionic-angular';
import * as $ from 'jquery';
import * as _ from 'lodash';
import * as debug from 'debug';
import { Media } from '@capacitor-community/media';
import { CrudApiProvider } from '../crud-api/crud-api';
import { ToolsProvider } from '../tools/tools';
import { Filesystem, Directory } from '@capacitor/filesystem';

declare let CmKit: any;
let touchstartX = 0,
  touchendX = 0,
  viewer,
  dotMenu,
  buttons,
  viewerElement,
  viewerInterval,
  backButtonSub,
  imagesCountDisplay,
  allImages,
  imgIndex;

@Injectable()
export class ImageViewerProvider {
  log = debug('app:ImageViewerProvider');

  constructor(
    public crudApi: CrudApiProvider,
    public platform: Platform,
    public tools: ToolsProvider,
    public toastCtrl: ToastController
  ) {}

  open(src, opts?) {
    if (_.get(opts, 'images')) {
      let idToCheck = opts.image._id;
      allImages = opts.images;
      imgIndex = allImages.findIndex(img => img._id === idToCheck);
    }

    viewer = viewer || new FullScreenViewer({});

    // there is a workflow where we attach the div to a modal that could get
    // removed from the dom - we start fresh in this case
    if (!$('.iv-fullscreen').length) {
      viewer = new FullScreenViewer({});
    }

    this.clearBackButton();

    if (!src) {
      return;
    }

    if (_.get(opts, 'takePhotoButton')) {
      buttons.push(_.get(opts, 'takePhotoButton'));
    }

    if (_.get(opts, 'choosePhotoButton')) {
      buttons.push(_.get(opts, 'choosePhotoButton'));
    }

    viewer.show(src);

    // move it in the dom so the action sheet will appear on top
    if ($('ion-modal').length) {
      $('.iv-fullscreen').prependTo('ion-modal');
    } else {
      $('.iv-fullscreen').prependTo('ion-app');
    }

    backButtonSub = this.platform.registerBackButtonAction(e => {
      viewer.hide();
    }, 99999);

    viewerInterval = setInterval(() => {
      if (!this.isVisible()) {
        this.clearBackButton();
      }
    }, 10);

    $('.iv-fullscreen-close').css({
      left: '10px',
      background: 'rgba(0, 0, 0, 0.6)',
      borderRadius: '50%',
    });

    this.addDotMenu(src);

    if (_.get(opts, 'images')) {
      this.addSwipeToImg();
      this.addImgCountTag();
    }

    $('.iv-fullscreen-close').click(() => {
      if (imagesCountDisplay) imagesCountDisplay.remove();
      viewer.destroy();
    });
  }

  checkDirection() {
    if (touchendX < touchstartX) {
      imgIndex = imgIndex + 1;
      imgIndex = imgIndex % allImages.length;
      viewer.show(allImages[imgIndex].imageUrl);
    }
    if (touchendX > touchstartX) {
      imgIndex = imgIndex - 1;
      imgIndex = imgIndex % allImages.length;
      if (imgIndex >= 0) {
        viewer.show(allImages[imgIndex].imageUrl);
      } else {
        let lastItem = allImages.slice(-1)[0];
        imgIndex = allImages.length - 1;
        viewer.show(lastItem.imageUrl);
      }
    }
    this.addDotMenu(allImages[imgIndex].imageUrl);
    this.addImgCountTag();
  }

  addSwipeToImg() {
    let swipeElem = document.querySelector('.iv-image-view');

    if (swipeElem) {
      swipeElem.addEventListener('touchstart', (e: TouchEvent) => {
        touchstartX = e.changedTouches[0].screenX;
      });
      swipeElem.addEventListener('touchend', (e: TouchEvent) => {
        touchendX = e.changedTouches[0].screenX;
        if (touchstartX != touchendX) {
          this.checkDirection();
        }
      });
    }
  }

  addImgCountTag() {
    if (imagesCountDisplay) {
      imagesCountDisplay.remove();
    }
    imagesCountDisplay = $(
      '<div style="display:flex; justify-content:center;  color:white; position:absolute; z-index:10000; right:50%; top:20px;"></div>'
    )
      .addClass('iv-images-count')
      .html(`<div>${imgIndex + 1}/${allImages.length}</div>`);

    $('.iv-fullscreen-container').append(imagesCountDisplay);
  }

  addDotMenu(src) {
    if (dotMenu) dotMenu.remove();

    buttons = [
      {
        icon: '<i class="fal fa-user"></i>',
        text: 'Save Photo',
        handler: () => {
          this.tools.logAnalyticsEvent('trackCustom', 'save-photo-to-device');
          this.saveImage(src);
        },
      },
    ];
    dotMenu = $('<div></div>')
      .addClass('iv-dot-menu')
      .html(
        `<i class="fal fa-ellipsis-h fa-2x" style="background: rgba(0, 0, 0, 0.6); padding: 2px 7px; border-radius: 50%"></i>`
      );
    $('.iv-fullscreen-container').append(dotMenu);
    $('.iv-dot-menu').click(() => {
      CmKit.ActionSheet({
        props: {
          template: [],
          buttons: buttons,
        },
      });
    });
  }

  close() {
    if (viewer) {
      viewer.hide();
      viewer.destroy();
    }
  }

  async saveImage(imageUrl: string, albumName: string = '', opts: any = {}) {
    try {
      let albumIdentifier = '';
      let albumIdentifierPath = 'identifier';
      const platform = this.platform.is('ios')
        ? 'ios'
        : this.platform.is('android')
        ? 'android'
        : 'web';

      const imageTempFile = `${new Date().getTime()}.jpeg`;

      // We are downloading and converting to base64 on the server to avoid CORS
      // issues with cloudfront. If we ever change this, we can uncomment and
      // use _readAsBase64 down below.
      let imageAsBase64;
      if (_.get(opts, 'isBase64')) {
        imageAsBase64 = imageUrl;
      } else {
        imageAsBase64 = await this._getBase64FromAPI(imageUrl);
      }

      // Save the image locally to Cache folder
      const imageTemp = await Filesystem.writeFile({
        path: imageTempFile,
        data: imageAsBase64,
        directory: Directory.Cache,
      });

      if (platform === 'android') {
        // force android album name due to plugin constrai
        albumName = 'CDLLife App';
        albumIdentifierPath = 'name';
      }

      let albums = await Media.getAlbums();

      albumIdentifier =
        _.get(
          albums.albums.find(a => a.name === albumName),
          albumIdentifierPath
        ) || null;

      if (platform === 'ios') {
        if (!albumIdentifier && albumName) {
          // Doesn't exist, create new album
          await Media.createAlbum({ name: albumName });
          albums = await Media.getAlbums();
          albumIdentifier = _.get(
            albums.albums.find(a => a.name === albumName),
            albumIdentifierPath
          );
        }
      } else if (platform === 'android') {
        this.log('checking for existing album', albumName);

        if (!albumIdentifier && albumName) {
          // Doesn't exist, create new album

          try {
            albumIdentifier = albumName;
            await Media.createAlbum({ name: albumName });
          } catch (e) {
            // existing albums aren't always returned by media.createAlbum,
            // so we stifle this in order to still save to the album specified

            // @TODO Simplify when issue https://github.com/capacitor-community/media/issues/6 is fixed
            this.log('album already exists, carry on');
          }
        }
      }

      const saveMediaOpts = {
        path: imageTemp.uri,
      };

      if (albumName && albumIdentifier) {
        saveMediaOpts['album'] =
          platform === 'ios' ? albumIdentifier : albumName;
      }

      this.log('starting save photo', saveMediaOpts);

      if (platform === 'web') {
        return this.log('web platform, skipping save image');
      }

      Media.savePhoto(saveMediaOpts)
        .then(() => {
          const toast = this.toastCtrl.create({
            message: 'Photo saved to device',
            position: 'top',
            duration: 2500,
          });
          toast.present();
        })
        .catch(e => {
          this.log('error', e);
          const toast = this.toastCtrl.create({
            message: 'Error saving to device',
            position: 'top',
            duration: 2500,
          });
          toast.present();
        });
    } catch (e) {
      this.log('catch error', e);
      const toast = this.toastCtrl.create({
        message: 'Error saving to device',
        position: 'top',
        duration: 2500,
      });
      toast.present();
      this.log('error saving image to device', e);
    }
  }

  private async _getBase64FromAPI(url): Promise<any> {
    return new Promise((resolve, reject) => {
      this.crudApi.post('/api/utilities/convertImageToBase64', { url }).then(
        res => {
          return resolve(_.get(res, 'data'));
        },
        e => {
          return reject('error converting image to base64');
        }
      );
    });
  }

  // private async _readAsBase64(url: string): Promise<string> {
  //   // Fetch the photo, read as a blob, then convert to base64 format
  //   const response = await fetch(url);
  //   const blob = await response.blob();
  //   return await this._convertBlobToBase64(blob);
  // }

  // private async _convertBlobToBase64(blob: Blob): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onerror = reject;
  //     reader.onload = () => resolve(reader.result as string);
  //     reader.readAsDataURL(blob);
  //   });
  // }

  private clearBackButton() {
    clearInterval(viewerInterval);
    if (backButtonSub) {
      backButtonSub();
      backButtonSub = null;
    }
  }

  private isVisible() {
    viewerElement = viewerElement || document.querySelector('.iv-fullscreen');
    if (viewerElement && viewer) {
      try {
        if (viewerElement.style.display === 'block') {
          return true;
        }
      } catch (e) {}
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/image-viewer/image-viewer.ts